import { authService } from '../services/authService';

let isRefreshing = false;
let refreshQueue = [];

export function initApiInterceptors(api) {
  function axiosRequestSuccessInterceptor(config) {
    const token = authService.getAuthToken();

    config.headers.Authorization = token ? `Bearer ${token}` : '';

    return config;
  }

  function axiosResponseErrorInterceptor(error) {
    const {
      config: originalConfig,
      response: { status } = {},
    } = error;

    if (status !== 401) {
      return Promise.reject(error);
    }

    if (!authService.getAuthToken()) {
      return Promise.reject(error);
    }

    if (!isRefreshing) {
      isRefreshing = true;

      authService.refreshToken()
        .then(() => {
          const tokenValue = authService.getAuthToken();

          refreshQueue.forEach((v) => v.resolve(tokenValue));
          refreshQueue = [];
        })
        .catch(() => {
          refreshQueue.forEach((v) => v.reject(error));
          refreshQueue = [];

          authService.setLoggedOut();
        })
        .finally(() => {
          isRefreshing = false;
        });
    }

    return new Promise((resolve, reject) => {
      refreshQueue.push({
        resolve: (tokenValue) => {
          const config = {
            ...originalConfig,
            headers: {
              ...originalConfig.headers,
              Authorization: `Bearer ${tokenValue}`,
            },
          };

          resolve(api.request(config));
        },
        reject: (err) => {
          reject(err);
        },
      });
    });
  }

  api.interceptors.request.use(axiosRequestSuccessInterceptor, null);
  api.interceptors.response.use(null, axiosResponseErrorInterceptor);
}
